var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "filters-page",
      on: {
        click: function($event) {
          return _vm.closeFilters()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "filters-page-container",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("div", { staticClass: "filter-header" }, [
            _c("p", [
              _vm._v("Filters "),
              _vm.totalCurrentFilters > 0
                ? _c("span", [
                    _vm._v("(" + _vm._s(_vm.totalCurrentFilters) + ")")
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("img", {
              staticClass: "x",
              attrs: {
                src:
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652",
                alt: "x"
              },
              on: {
                click: function($event) {
                  return _vm.closeFilters()
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filters-container" },
            [
              _c("div", { staticClass: "product-sort" }, [
                _c("span", [_vm._v("Sort By")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedSortMobile,
                        expression: "selectedSortMobile"
                      }
                    ],
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectedSortMobile = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "1" } }, [
                      _vm._v("Recommended")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "2" } }, [
                      _vm._v("Best Seller")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "3" } }, [_vm._v("New")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "4" } }, [
                      _vm._v("Price Low to High")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "5" } }, [
                      _vm._v("Price High to Low")
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("OccasionFilter"),
              _vm._v(" "),
              _vm.maxMinPrices
                ? _c("PriceFilter", { attrs: { prices: _vm.maxMinPrices } })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "button-container" }, [
            _c(
              "button",
              {
                staticClass: "happybox-button white border",
                on: { click: _vm.resetFilters }
              },
              [_vm._v("Reset")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "happybox-button green border",
                on: { click: _vm.applyFilters }
              },
              [_vm._v("Apply")]
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }